import React, { FC, useContext } from "react";
import ReactHtmlParser from "react-html-parser";

import Multimedia from "@sharedComponents/multimedia";
import MultiCarousel from "@stadium/ui/src/components/multi-carousel";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { ExternalButton } from "@sharedComponents/buttons";

import styles from "./main.module.scss";

interface DefaultObjType {
  [key: string]: any;
}

type AutoInfiniteCarouselProps = {
  data: any;
  content: {
    buttonText?: string;
    buttonLink?: string;
    cardDetails: { tileImg: string; titleImg: string; title: string }[];
    bgImg: string;
  };
};

const defaultObj: DefaultObjType = {};

const AutoInfiniteCarousel: FC<AutoInfiniteCarouselProps> = ({ data, content }) => {
  const { buttonText, cardDetails, buttonLink, bgImg } = content || defaultObj;
  const { jsonContent } = data || defaultObj;
  const { rte_content = "" } = (jsonContent && JSON.parse(jsonContent)) || defaultObj;
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const renderCarouselItem = ({ tileImg, title, titleImg }) => (
    <div className={styles.slidesContainer}>
      <Multimedia
        src={tileImg}
        alt={title}
        type="image"
        isNextImage={false}
        className={styles.tileImg}
      />
      <div className={styles.cardDetails}>
        <Multimedia
          src={titleImg}
          alt={title}
          type="image"
          isNextImage={false}
          className={styles.titleImg}
        />
        <h5 className={styles.cardTitle}>{title}</h5>
      </div>
    </div>
  );
  const renderCarouselItemList = () => cardDetails.map((details) => renderCarouselItem(details));

  return (
    <div className={styles.sliderContainer} style={{ backgroundImage: `url(${bgImg})` }}>
      <div className={styles.sliderHeader}>
        <div className={styles.sliderHeading}>{rte_content && ReactHtmlParser(rte_content)}</div>
      </div>
      <MultiCarousel
        resolutionCountsMapping={{ superLarge: 9, desktop: 7, tablet: 4, mobile: 2 }}
        partialVisible
        autoPlay
        arrows={false}
        transitionDuration={isMobileDevice ? 10000 : 30000}
        customTransition={`all ${isMobileDevice ? 10 : 30}s linear`}
        autoPlaySpeed={1}
        itemClass={styles.sliderItem}
        containerClass={styles.globalSlider}
        slidesToSlide={7}
        draggable={false}
        pauseOnHover={false}
        swipeable={false}
      >
        {renderCarouselItemList()}
      </MultiCarousel>

      {buttonText && (
        <div className={styles.sliderButtonContainer}>
          <ExternalButton
            href={buttonLink}
            className={styles.sliderButton}
            styleType="primary"
            title={buttonText}
          >
            {buttonText}
          </ExternalButton>
        </div>
      )}
    </div>
  );
};

export default AutoInfiniteCarousel;
